import { render, staticRenderFns } from "./BuffetSummary.vue?vue&type=template&id=f507bfe8&scoped=true&"
import script from "./BuffetSummary.vue?vue&type=script&lang=js&"
export * from "./BuffetSummary.vue?vue&type=script&lang=js&"
import style0 from "./BuffetSummary.vue?vue&type=style&index=0&id=f507bfe8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f507bfe8",
  null
  
)

export default component.exports